<template>
    <div class="d-flex justify-content-center">
        <div class="position-relative user-select-none w-100 px-2" style="display: grid; grid-template-columns: repeat(6, 1fr); max-width: 1060px">
            <template v-for="(step, index) in store.steps">
                <div v-if="index < 6" class="step fw-600 mb-1" :class="{'active': store.currentStep >= index, 'disabled': !step.enabled}" @click="handleClick(step, index)">
                    <div ref="step-circle" class="step-circle">
                        {{ index+1 }}
                    </div>

                    <label class="text-center d-none d-md-block">{{step.stepTitle}}</label>
                </div>
            </template>

            <div class="position-absolute d-flex justify-content-center" style="left: 0; right: 0; top: 19px;">
                <div style="border-top: 1px solid #C64885; width: 80%"></div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @mixin activeCircle {
        .step-circle {
            color: white;
            background: var(--color);
        }
    }

    .step {
        --color: #C64885;

        display: flex;
        flex-direction: column;
        align-items: center;

        color: var(--color);

        &:hover {
            @include activeCircle;
        }

        &.active {
            @include activeCircle;
        }

        cursor: pointer;
        label {
            cursor: pointer;
        }

        &.disabled {
            cursor: not-allowed;

            label {
                cursor: not-allowed;
            }
        }
    }

    .step-circle {
        aspect-ratio: 1 / 1;
        width: 39px;
        background: rgb(245, 245, 245);
        border: 1px solid var(--color);

        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100%;
        z-index: 1;
    }
</style>

<script>
import {useFlexiblePackagingStore} from "../js/store";

export default {
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
    methods: {
        handleClick(step, index) {
            if (!step.enabled) return;

            this.store.gotoStep(index);
        }
    }
}
</script>
